import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "travelServe scenicspotContainer"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "scenicspotList"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "itemimg"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "itemtxt"
};
const _hoisted_9 = {
  class: "title clearfix"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "itemfun clearfix"
};
const _hoisted_14 = {
  key: 0,
  class: "address textover"
};
const _hoisted_15 = {
  class: "detail"
};
const _hoisted_16 = {
  class: "browsevalue"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Right = _resolveComponent("Right");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_View = _resolveComponent("View");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "labelBox"
  }, null, -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "scenicspotItem",
      key: item.id
    }, [_createElementVNode("a", {
      href: $options.goLink(item),
      target: "_blank"
    }, [_createElementVNode("div", _hoisted_5, [item.itemformdata[8] !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("i", null, _toDisplayString(item.itemformdata[8]), 1)])) : _createCommentVNode("", true), _createElementVNode("img", {
      class: "imgcover",
      src: item.itemformdata[3],
      alt: ""
    }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h2", null, [item.itemformdata[37] === '免费' ? (_openBlock(), _createElementBlock("span", _hoisted_10, "免费")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.itemformdata[2]), 1)]), item.itemformdata[19] !== '' ? (_openBlock(), _createElementBlock("h3", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[19]), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "desc",
      innerHTML: item.itemformdata[12]
    }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [item.itemformdata[36] !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_14, "地址：" + _toDisplayString(item.itemformdata[36]), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_15, [_cache[0] || (_cache[0] = _createTextVNode("详情", -1)), _createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Right)]),
      _: 1
    })]), _createElementVNode("span", _hoisted_16, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_View)]),
      _: 1
    }), _createElementVNode("b", null, _toDisplayString(item.itemformdata[15] === '' ? 0 : item.itemformdata[15]), 1)])])])], 8, _hoisted_4)]);
  }), 128))]), $data.totalPage > 1 ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    "page-size": $data.formconfig.limit,
    "pager-count": 5,
    layout: "prev, pager, next",
    total: $data.total,
    background: "",
    onCurrentChange: $options.currentChange,
    class: "pagemodel1"
  }, null, 8, ["page-size", "total", "onCurrentChange"])) : _createCommentVNode("", true)])]);
}